import baseUrl from '../baseUrl'
export default {
  parameters: baseUrl + '/v1/pay/parameters',
  pay: baseUrl + '/v1/pay/pay',
  cancel: baseUrl + '/v1/pay/cancel',
  payActCode: baseUrl + '/v1/order/pro',
  getProInfo: baseUrl + '/v1/order/code-product',
  getFieldPro: baseUrl + '/v1/order/field-product',
  payField: baseUrl + '/v1/order/field-pay',
}
